import React, { useEffect, useRef, useState } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import MyLocationIcon from "@mui/icons-material/MyLocation";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const defaultCenter = { lat: 20.5937, lng: 78.9629 }; // India center

const MapComponent = ({ isOpen, onSelect, address , height= "400px" }) => {
  const mapRef = useRef(null);
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setLoading(false);
    }
  }, [isOpen]);

  // ✅ Geocode address when it changes (only if user hasn't already selected pin)
  useEffect(() => {
    if (isOpen && address && window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;
          const latLng = { lat: location.lat(), lng: location.lng() };
          setMapCenter(latLng);
          // Only update pin if user hasn't moved it yet
          if (!selectedPoint) {
            setSelectedPoint(latLng);
            if (onSelect) onSelect(latLng);
          }
        } else {
          console.warn("Geocode failed:", status);
        }
      });
    }
  }, [address, isOpen]);  // removed selectedPoint from deps to avoid overwrite

  const handleMapClick = (e) => {
    const latLng = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };
    setSelectedPoint(latLng);
    if (onSelect) onSelect(latLng);
  };

  const handleLocateMe = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setMapCenter(userLocation);
          setSelectedPoint(userLocation);
          if (onSelect) onSelect(userLocation);
        },
        () => {
          console.warn("Geolocation permission denied");
        }
      );
    }
  };

  return (
    <div className="relative">
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <CircularProgress />
        </div>
      ) : (
        <>
          <GoogleMap
             mapContainerStyle={{ width: '100%', height }}
            center={mapCenter}
            zoom={16}
            onClick={handleMapClick}
            onLoad={(map) => (mapRef.current = map)}
            options={{
              disableDefaultUI: true,
              zoomControl: true,
              gestureHandling: "greedy",
              draggable: true,
            }}
          >
            {selectedPoint && (
              <Marker position={selectedPoint} draggable={false} />
            )}
          </GoogleMap>

          {/* Floating locate me button */}
          <Tooltip title="Locate Me">
            <IconButton
              size="large"
              onClick={handleLocateMe}
              style={{
                position: "absolute",
                top: 10,
                left: 10,
                background: "#fff",
                boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
              }}
            >
              <MyLocationIcon color="primary" />
            </IconButton>
          </Tooltip>

          {/* Overlay message */}
          <div className="absolute top-2 left-1/2 transform -translate-x-1/2 bg-black text-white px-3 py-1 rounded-full text-xs pointer-events-none">
            Move Pin To Adjust
          </div>
        </>
      )}
    </div>
  );
};

export default MapComponent;
